module.exports = __webpack_public_path__ + "img/picto-un-papa-une-maman.8e00435c.svg";